/**
 * This utility is used for locales.
 */
export default class LocaleUtility {
	/**
	 * Converts a locale to country and language.
	 *
	 * @param locale Locale. Example: en-GB.
	 * @returns Country and language.
	 */
	public static getCountryAndLanguage(locale: string): {
		country: string | null;
		language: string | null;
	} {
		const list = locale.split('-');
		if (list.length > 1 && list[0].length === 2 && list[1].length === 2) {
			return {
				country: list[1].toLowerCase(),
				language: list[0].toLowerCase()
			};
		}
		return {
			country: null,
			language: null
		};
	}
}
